module.exports = {"361181001":"银城街道","361181002":"新营街道","361181003":"香屯街道","361181103":"绕二镇","361181105":"海口镇","361181106":"新岗山镇","361181107":"泗洲镇","361181190":"花桥镇","361181200":"黄柏乡","361181201":"万村乡","361181202":"张村乡","361181203":"昄大乡","361181204":"李宅乡","361181205":"龙头山乡","361181401":"江西省德兴铜矿"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361181.json
// module id = 1249
// module chunks = 0